// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","520":"260fb190","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"d42489da90562e61a407","520":"bf184a9aca37f0dc2538","678":"ef1d28bf58ab893e724a","883":"645d039d25b61758c82f"}[chunkId] + ".js";
};